module.exports = __webpack_public_path__ + "static/media/24_CalTrain - San Francisco.1fe9f1a6.jpg";